import styled from 'styled-components';

import { StyleColor } from '../../../utils/styles-constants';

interface StyledThumbnailsIconProps {
	isActive: boolean;
	width?: number;
	isCustomBackground?: boolean;
	isBackgroundOnActiveState?: boolean;
}

interface CustomBackgroundProps {
	width?: number;
}

const StyledFileIcon = styled('div')`
	position: relative;
	flex: 0 0 16px;
	height: 16px;
	margin-right: 6px;
	border-radius: 4px;
	background-color: ${(props: StyledThumbnailsIconProps) => {
		if (props.isBackgroundOnActiveState) {
			return props.isActive ? `${StyleColor.White}` : '';
		}

		return props.isCustomBackground ? '' : `${StyleColor.White}`;
	}};

	> svg {
		position: relative;
		z-index: 1;
		width: ${(props: StyledThumbnailsIconProps) => props.width ? `${props.width}px` : '16px'};
		height: 16px;
		fill: ${(props: StyledThumbnailsIconProps) => props.isActive ? `${StyleColor.Black}` : ''};
	}
`;

const CustomBackground = styled('div')`
	position: absolute;
	top: 0;
	left: 0;

	svg {
		width: ${(props: CustomBackgroundProps) => props.width ? `${props.width}px` : '16px'};
		height: 16px;
	}
`;

export {
	StyledFileIcon,
	CustomBackground,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/FileIcon/styles.ts